import React, { useMemo } from 'react';
import { useAppSelector } from 'store/hooks';
import StockSearchResult from './StockSearchResult';
import useStockMeta from '../hooks/useStockMeta';
const TrendingStock = ({ assetId, isFirstItem, isLastItem }) => {
    const stockMeta = useStockMeta(assetId);
    // Funds lists don't return descriptions, but the funds search usually has already loaded them.
    // Using it avoids the row growing once the stock meta request comes back.
    const secclAsset = useAppSelector((state) => state.unpersistedInvestReducer.secclAssets?.find((asset) => asset.id === assetId));
    const dataWithFirstAndLastInfo = useMemo(() => ({
        id: assetId,
        name: stockMeta?.name || secclAsset?.name || '',
        symbol: stockMeta?.symbol,
        icon: stockMeta?.iconUrl || secclAsset?.icon || '',
        description: stockMeta?.description || secclAsset?.description,
        shortDescription: stockMeta?.shortDescription || secclAsset?.shortDescription,
        averageAnnualReturn: stockMeta?.averageAnnualReturn,
        isFirstItem,
        isLastItem,
    }), [assetId, stockMeta, secclAsset, isFirstItem, isLastItem]);
    return <StockSearchResult data={dataWithFirstAndLastInfo}/>;
};
export default React.memo(TrendingStock);
